import { apiCap } from "@gik/api";
import { useTaxonomies } from "@gik/api/give/taxonomies";
import { FetchProvider } from "@gik/core/components/DynamicComponent/FetchProvider";
import React from "react";
import type { GiftTypeGridProps } from "./GiftTypeGrid";
import { GiftTypeGrid, GiftTypeGridSkeleton } from "./GiftTypeGrid";

export function GiftTypeGridWithData(props: GiftTypeGridProps) {
	const { items } = props;

	const useFetch = () => {
		return useTaxonomies(
			"category",
			{ page: 1, perPage: apiCap },
			{
				fallbackData: items,
			},
		);
	};

	return (
		<FetchProvider
			fetch={useFetch}
			loadingComponent={<GiftTypeGridSkeleton {...props} />}
		>
			{({ data }) => <GiftTypeGrid {...props} items={data} />}
		</FetchProvider>
	);
}
